"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretLeft = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CaretLeft = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M14.515 6.207a.7.7 0 01.994 0l.28.28a.686.686 0 01.21.504v10.018a.686.686 0 01-.21.504l-.28.28a.7.7 0 01-.994 0L9.212 12.49a.672.672 0 010-.98l5.303-5.303z" })); };
exports.CaretLeft = CaretLeft;
//# sourceMappingURL=caret-left.js.map